import { history } from 'syft-acp-core/history'

export const navigateListing = ({ shiftID, jobID, listingID }) => {
  if (!shiftID) {
    history.push(`/listings/view/${listingID}/job/${jobID}`)
  } else {
    history.push(`/listings/view/${listingID}/job/${jobID}/shift/${shiftID}`)
  }
}
